import axios from "axios";
import { useEffect, useRef, useState } from "react";

import { useMain } from "@/contexts/mainContext";
import { api } from "@/lib/axios";

export function QueroUmaPerucaFormStep6() {
  const { data, status, setStatus } = useMain();

  const [errorMessage, setErrorMessage] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);

  const hasSent = useRef(false);

  useEffect(() => {
    if (hasSent.current) {
      return;
    }

    hasSent.current = true;

    async function sendData() {
      try {
        setErrorMessage("");
        setStatus(0);
        setUploadProgress(0);

        const formData = new FormData();

        formData.append("name", data.name);
        formData.append("email", data.email);
        formData.append("phone", data.phone);
        formData.append("rg", data.rg);
        formData.append("cpf", data.CPF);
        formData.append("cep", data.cep);
        formData.append("address", data.address);
        formData.append("number", data.number);
        formData.append("complement", data.complement ?? "");
        formData.append("cityUF", data.cityUF);
        formData.append("hospital", data.hospital);
        formData.append("perucaIdealTipo", data.perucaIdealTipo);
        formData.append("perucaIdealComprimento", data.perucaIdealComprimento);
        formData.append("perucaIdealCor", data.perucaIdealCor);
        formData.append("comoficousabendo", data.comoficousabendo);

        data.docs?.forEach((file) => {
          formData.append("docs[]", file);
        });

        formData.append("terms", data.terms ? "Sim" : "Não");

        /*
         * Solicitação principal.
         *
         * Essa é a operação importante.
         */
        const response = await api.post("/solicitacao", formData, {
          timeout: 120000,

          onUploadProgress: (progressEvent) => {
            if (!progressEvent.total) {
              return;
            }

            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );

            setUploadProgress(percent);
          },
        });

        setStatus(response.status);

        /*
         * Newsletter é secundária.
         * Não pode bloquear o pedido da peruca.
         */
        if (data.terms) {
          api
            .post("/newsletter", {
              data: {
                email: data.email,
              },
            })
            .catch((error) => {
              console.error("Erro ao cadastrar newsletter:", error);
            });
        }
      } catch (error) {
        console.error("Erro ao enviar solicitação:", error);

        setStatus(-1);

        if (axios.isAxiosError(error)) {
          if (error.code === "ECONNABORTED") {
            setErrorMessage(
              "O envio demorou mais que o esperado. Verifique sua conexão e tente novamente.",
            );

            return;
          }

          if (error.response?.status === 413) {
            setErrorMessage(
              "Os arquivos enviados são muito grandes. Reduza o tamanho dos documentos e tente novamente.",
            );

            return;
          }

          if (error.response?.status === 422) {
            setErrorMessage(
              error.response.data?.text ??
                "Alguns dados ou documentos não são válidos. Revise o formulário e tente novamente.",
            );

            return;
          }

          if (!error.response) {
            setErrorMessage(
              "Não foi possível conectar ao servidor. Verifique sua internet e tente novamente.",
            );

            return;
          }

          setErrorMessage(
            error.response.data?.text ??
              "Não foi possível enviar sua solicitação. Tente novamente.",
          );

          return;
        }

        setErrorMessage("Ocorreu um erro inesperado. Tente novamente.");
      }
    }

    sendData();
  }, []);

  if (status === 0) {
    return (
      <div className="flex flex-col gap-3">
        <span className="font-roboto text-lg font-bold text-pink-650">
          {uploadProgress < 100
            ? `Enviando documentos... ${uploadProgress}%`
            : "Finalizando sua solicitação..."}
        </span>

        <div className="h-2 w-full overflow-hidden rounded-full bg-pink-100">
          <div
            className="h-full bg-pink-650 transition-all duration-300"
            style={{
              width: `${uploadProgress}%`,
            }}
          />
        </div>

        <span className="font-roboto text-sm text-pink-650">
          Não feche esta página enquanto o envio estiver em andamento.
        </span>
      </div>
    );
  }

  if (status === -1) {
    return (
      <div className="rounded-md border-[3px] border-red-500 p-4">
        <div className="flex flex-col gap-4">
          <span className="font-roboto text-sm font-normal text-red-600">
            {errorMessage}
          </span>

          <button
            type="button"
            onClick={() => window.location.reload()}
            className="w-full rounded-md bg-pink-650 px-4 py-3 font-roboto font-bold text-white"
          >
            Tentar novamente
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-md border-[3px] border-pink-650 p-4 max-[1279px]:p-4 max-[1024px]:h-auto">
      <div className="flex flex-col gap-4">
        <div className="block font-roboto text-sm font-normal text-pink-650 max-[1279px]:text-center max-[480px]:text-sm">
          <span className="block pb-1">
            Nossa equipe entrará em contato em até <strong>5 dias úteis</strong>{" "}
            para dar seguimento ao seu pedido! Caso não respondamos em{" "}
            <strong>5 dias úteis</strong>, por favor entrar em contato
            novamente.
          </span>

          <strong>
            Fique de olho no seu e-mail, entraremos em contato por lá!
          </strong>
        </div>
      </div>
    </div>
  );
}
